import { useSelector } from 'react-redux';
import {
  selectElementDependencies,
  selectOrgSweepFields,
} from '../../../../reducers/global/globalReducer';
import { ElementDependencies } from '../../../../reducers/global/globalReducerTypes';
import { ConfigurationItemMap } from '../../configuration-item-tables/shared/helpers';
import { createConfigurationItemFromSweepField } from '../../helpers';
import { SweepElementTypes } from '../../types';
import { FIELD } from '@server/parser';
import {
  ROLLUP,
  SWEEP_ALERT,
  SWEEP_ASSIGNMENT,
  SWEEP_AUTOMATION,
  SWEEP_DEDUPE,
  SWEEP_MATCHING,
  SWEEP_SCHEDULED_ASSIGNMENT,
} from '../../../parser/ParserTypes';

const SWEEP_ELEMENT_TYPE_TO_FIELD_TYPE = {
  [SWEEP_AUTOMATION]: 'automations',
  [SWEEP_ALERT]: 'alerts',
  [SWEEP_ASSIGNMENT]: 'assignments',
  [SWEEP_SCHEDULED_ASSIGNMENT]: 'scheduledAssignments',
  [SWEEP_DEDUPE]: 'dedup',
  [SWEEP_MATCHING]: 'matching',
  [ROLLUP]: 'rollups',
};

export const useGetSweepElementsDependencies = (
  crmOrgId: string,
  configurationItemId: string,
  sweepElementType: SweepElementTypes,
  activeOnly: boolean,
) => {
  const fieldType = SWEEP_ELEMENT_TYPE_TO_FIELD_TYPE[sweepElementType];
  const elementDependencies = useSelector(selectElementDependencies(crmOrgId));
  const sweepFields = useSelector(selectOrgSweepFields(crmOrgId));

  const fields =
    elementDependencies?.[fieldType as keyof ElementDependencies]?.[configurationItemId];

  const dependencies = {
    [FIELD]:
      fields
        ?.map((fieldId) =>
          sweepFields && sweepFields[fieldId]
            ? createConfigurationItemFromSweepField(sweepFields[fieldId])
            : undefined,
        )
        ?.filter((item) => (activeOnly ? !!item && item.isActive : !!item)) ?? [],
  };

  return dependencies as ConfigurationItemMap;
};
